import { render, staticRenderFns } from "./DamageRepairInfo.vue?vue&type=template&id=bfe13cba"
import script from "./DamageRepairInfo.vue?vue&type=script&lang=ts"
export * from "./DamageRepairInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports